import PropTypes from 'prop-types';
import {createContext, useContext, useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {onSignInUser, onVerifyUser} from 'redux/actions';
import {GLOBAL_RESET} from 'shared/constants/ActionTypes';
import {isAuthorized, setAuthInfo} from '.';

const JWTAuthContext = createContext();
const JWTAuthActionsContext = createContext();
export const useJWTAuth = () => useContext(JWTAuthContext);
export const useJWTAuthActions = () => useContext(JWTAuthActionsContext);

const initialState = {
  user: null,
  isAuthenticated: false,
  isLoading: false,
};

const JWTAuthAuthProvider = ({children}) => {
  const [jwtAuthData, setJWTAuthData] = useState({
    ...initialState,
    isLoading: true, // Initializing with isLoading: true
  });

  const dispatch = useDispatch();
  const authInfo = useSelector(({memberReducer}) => memberReducer.authInfo);

  useEffect(() => {
    let authorized = isAuthorized(authInfo);

    if (authorized) {
      setAuthInfo(authInfo);
      setJWTAuthData({
        user: authInfo,
        isLoading: false,
        isAuthenticated: true,
      });
    } else {
      setAuthInfo(null);
      setJWTAuthData(initialState);
    }
  }, [dispatch, authInfo]);

  const signInUser = async (email) => {
    dispatch(onSignInUser(email));
  };

  const verifyUser = async (token) => {
    dispatch(onVerifyUser(token));
  };

  const logout = async () => {
    setAuthInfo(null);
    dispatch({type: GLOBAL_RESET});
    setJWTAuthData(initialState);
    window.location.href = '/signin';
  };
  // useUnload(logout);

  return (
    <JWTAuthContext.Provider
      value={{
        ...jwtAuthData,
      }}
    >
      <JWTAuthActionsContext.Provider
        value={{
          signInUser,
          verifyUser,
          logout,
        }}
      >
        {children}
      </JWTAuthActionsContext.Provider>
    </JWTAuthContext.Provider>
  );
};
export default JWTAuthAuthProvider;

JWTAuthAuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
